import React from "react";

const MobileMenuIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 17" fill="currentColor">
      <rect x="0.5" y="0.5" width="28" height="2" fill="currentColor" />
      <rect x="0.5" y="8.5" width="28" height="2" fill="currentColor" />
      <rect x="0.5" y="16.5" width="28" height="2" fill="currentColor" />
    </svg>
  );
};

export default MobileMenuIcon;
